/**
 * Login page — SSO via Cognito Managed Login
 * Redirects to Brain Dance auth portal for OTP sign-in.
 */
import { redirectToLogin } from '@codespeak11/cognito-passwordless';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function Login() {
  const location = useLocation();
  const autoRedirectStartedRef = useRef(false);
  const hasBookId = new URLSearchParams(location.search).has('bookId');

  useEffect(() => {
    if (!hasBookId || autoRedirectStartedRef.current) {
      return;
    }

    autoRedirectStartedRef.current = true;
    void redirectToLogin();
  }, [hasBookId]);

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: 3,
        }}
      >
        <Typography variant="h3" component="h1" fontWeight="bold">
          PromptFab
        </Typography>
        <Typography variant="body1" color="text.secondary" textAlign="center">
          Optimize, analyze, and manage your AI prompts with PAIQ scoring
        </Typography>

        {hasBookId && (
          <Typography variant="body2" color="text.secondary" textAlign="center">
            Sign-in is required to import your book prompt pack. Redirecting to secure login...
          </Typography>
        )}

        <Button
          variant="contained"
          size="large"
          onClick={() => redirectToLogin()}
          sx={{ py: 1.5, px: 4, mt: 2 }}
        >
          Sign In
        </Button>

        <Typography variant="caption" color="text.secondary" sx={{ mt: 4 }}>
          Part of the Braindance platform
        </Typography>
      </Box>
    </Container>
  );
}
